import React, { forwardRef } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import isUndefined from 'lodash/isUndefined';
import { compose } from 'redux';
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { NUMBER_FORMATS } from 'numberFormats.js';

// LOCAL HELPERS
import { formGroup } from '../helpers/layout/formGroup';
import { inputLabel } from '../helpers/layout/inputLabel';
import { inputText } from '../helpers/layout/inputText';
import { inputAppend } from '../helpers/layout/inputAppend';
import { inputGroup } from '../helpers/layout/inputGroup';
import { copyButton } from '../helpers/toggles/copyButton';

// CORE COMPONENTS
import NumberFormat from 'core/tools/NumberFormat';

// STYLES
import styles from './plainText.module.scss';

// MAIN COMPONENT
const PlainTextComponent = compose(
  formGroup,
  inputLabel,
  inputText,
  inputAppend,
  inputGroup,
  copyButton,
  forwardRef
)(
  (
    {
      as: Component = 'div',
      className,
      name,
      value: valueProp,
      placeholder = '-',
      type = '',
      schema = '',
      numberFormat,
      hidden,
      fullWidth
    },
    ref
  ) => {
    // FORMIK
    const { values } = useFormikContext() || {};

    // CONSTANTS
    const format = numberFormat || NUMBER_FORMATS[schema || type];
    const value = !isUndefined(valueProp) ? valueProp : get(values, name);

    return (
      <Component
        className={clsx(
          'plaintext-value w-100',
          styles.value,
          hidden && 'd-none',
          fullWidth && styles.fullWidth,
          className
        )}
      >
        {![undefined, null, false, ''].includes(value) ? (
          !!format && !isObject(value) ? (
            <NumberFormat format={format} displayType="text" value={value} ref={ref} />
          ) : (
            <span ref={ref}>{value}</span>
          )
        ) : (
          placeholder
        )}
      </Component>
    );
  }
);

export default function PlainText(props) {
  return <PlainTextComponent {...props} plaintext />;
}
